/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Export_Too_LargeInputs */

const en_reports_export_too_large = /** @type {(inputs: Reports_Export_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This report is too large to export. Narrow it down by client.`)
};

const pt_br2_reports_export_too_large = /** @type {(inputs: Reports_Export_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este relatório é grande demais para exportar. Filtre por cliente.`)
};

/**
* | output |
* | --- |
* | "This report is too large to export. Narrow it down by client." |
*
* @param {Reports_Export_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_export_too_large = /** @type {((inputs?: Reports_Export_Too_LargeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Export_Too_LargeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_export_too_large(inputs)
	return pt_br2_reports_export_too_large(inputs)
});